var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDate = function SvgDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.547 2.4h-8.4a2.8 2.8 0 0 0-2.8 2.8v7a2.8 2.8 0 0 0 2.8 2.8h8.4a2.8 2.8 0 0 0 2.8-2.8v-7a2.8 2.8 0 0 0-2.8-2.8ZM5.547 1v2.8m5.6-2.8v2.8m-9.8 2.8h14",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgDate as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjU0NzIgMi40MDAxNUg0LjE0NzE3QzIuNjAwNzcgMi40MDAxNSAxLjM0NzE3IDMuNjUzNzUgMS4zNDcxNyA1LjIwMDE1VjEyLjIwMDFDMS4zNDcxNyAxMy43NDY1IDIuNjAwNzcgMTUuMDAwMSA0LjE0NzE3IDE1LjAwMDFIMTIuNTQ3MkMxNC4wOTM2IDE1LjAwMDEgMTUuMzQ3MiAxMy43NDY1IDE1LjM0NzIgMTIuMjAwMVY1LjIwMDE1QzE1LjM0NzIgMy42NTM3NSAxNC4wOTM2IDIuNDAwMTUgMTIuNTQ3MiAyLjQwMDE1WiIgc3Ryb2tlPSIjMzMzMzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuNTQ3MTcgMVYzLjhNMTEuMTQ3MiAxVjMuOE0xLjM0NzE3IDYuNkgxNS4zNDcyIiBzdHJva2U9IiMzMzMzMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";